import { cachedAxios } from '../services/cache/CachedAxios';

const FIN_SERVICE_URL = process.env.REACT_APP_FIN_SERVICE_URL;

interface RawTransactionResponse {
  rawTransaction: string;
  statusCode: number;
}

async function getRawTransaction(address: string, inputMint: string, outputMint: string, amountIn: number, slippage?: number): Promise<RawTransactionResponse> {
    const body = {
        wallet: address,
        inputMint,
        outputMint,
        amountIn,
        type: "sol",
        network: "mainnet",
        slippage: slippage || 0.01,
    }

    console.log('Sending request to API:', body);

    const response = await cachedAxios.post<RawTransactionResponse>(
      `${FIN_SERVICE_URL}/blockchain/create-swap-transaction`,
      body,
      { skipCache: true }
    );
    console.log('API response:', response);

    return response;
}

export async function createRawTransaction(address: string, inputMint: string, outputMint: string, amountIn: number, slippage?: number): Promise<RawTransactionResponse> {
    return await getRawTransaction(address, inputMint, outputMint, amountIn, slippage);
}
